import React from "react";
import BasePopup from "../Popup/index";
import bgPopupCongratu from "../../../../../assets/images/Event-2026/back-change-coin.png";
import titCongrat from "../../../../../assets/images/Event-2026/congrats-ribbonTBN.png";
import styled from "styled-components";
import bgButton from "../../../../../assets/images/Mini-Game/bg-button-change.png";
import { useDispatch, useSelector } from "@pages/Events/MiniGame/store";
import {
  setOpenPopupFooter,
  setOpenPopupPuzzle,
} from "../../../../../Redux/futures/mini-game/action";
import { curStateMiniGame } from "../../../../../Redux/selector";
import iconClosePopup from "../../../../../assets/images/Event-2026/exit.png";
import { useNavigate } from "@hooks/useNavigate";
import PATH from "../../../../../config/PATH";
import { ID_TAB_MINI_GAME } from "../../../../../helper/const";
import { useTranslation } from "react-i18next";

export default function PopupCongratulaPuzzle({ isOpen = true, className }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const dataMiniGame = useSelector(curStateMiniGame);
  const onCancel = () => {
    dispatch(
      setOpenPopupFooter({
        isShowPopup: false,
        step: null,
      })
    );

    dispatch(
      setOpenPopupPuzzle({
        isShow: false,
        data: null,
      })
    );
  };

  const navigate = useNavigate();

  return (
    <BasePopup
      BasePopup
      open={true}
      className={className}
      onCancel={onCancel}
      getContainer
    >
      <Container className="popup-cong-mini">
        <img
          src={iconClosePopup}
          alt=""
          className="rule-mini-close congratula-btn-close scale-hover-item"
          onClick={onCancel}
        />
        {/* <img src={bgPopupCongratu} alt="" className="bg-popup" /> */}
        <div className="popup-cong-mini-main">
          <div className="container-popup-cong-mini-main">
            <div className="content-main">
              <img className="tit_cong" src={titCongrat} alt="" />
              {t("mini_game.pop_up_congrats_take_prize.title").replace(
                "X",
                dataMiniGame?.popupPuzzle?.data?.prizeName || "XXXXXXXXX"
              )}
            </div>
            <div className="img-prize">
              <img src={dataMiniGame?.popupPuzzle?.data?.image} alt="" />
            </div>
            <div
              className="button-action-cong"
              onClick={() => {
                onCancel();
                navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.collectPiece}`);
              }}
            >
            </div>

            <div className="content-footer">
              {t("mini_game.pop_up_congrats_take_prize.sub")} <br />
              {t("mini_game.pop_up_congrats_take_prize.sub_trailing")}
            </div>
          </div>
        </div>
      </Container>
    </BasePopup>
  );
}

const Container = styled.div`
  position: relative;

  .congratula-btn-close {
    position: absolute;
    right: 10px;
    top: 15px;
    z-index: 3;
    cursor: pointer;
  }

  .tit_cong{
    margin-top: 50px;
  }

  .content-main,
  .content-coins,
  .content-footer {
    color: #fff;
    font-size: 16px;
    text-align: center;
    font-weight: 500;
  }

  .popup-cong-mini-main {
    position: relative;
    z-index: 2;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .container-popup-cong-mini-main {
    background-image: url(${bgPopupCongratu});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position-x: center;
    padding: 20px;
    border-radius: 26px;
    display: flex;
    flex-direction: column;
    grid-gap: 16px;
    gap: 16px;
    position: relative;

    // left: -1.5%;
    // position: relative;
    // padding-top: 60px;
  }

  .img-prize {
    text-align: center;
    margin: 10px 0;

    img {
      height: 245px;
      width: auto;
      object-fit: contain;
    }
  }

  .bg-popup {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 100%;
    height: calc(100% + 315px);
  }

  .button-action-cong {
    position: relative;
    margin-bottom: 10px;
    text-align: center;

    .button-action-cong-content {
      position: absolute;
      top: calc(50% - 4px);
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-size: 16px;
      font-weight: 500;
      width: 100%;
    }
    img {
      width: 300px;
      height: 50px;
    }
  }

  .content-footer {
    font-style: italic;
    font-weight: 400;
    font-size: 14px;
  }

  .content-coins {
    font-size: 38px;
    font-weight: 400;
    margin: 10px 0;
    font-family: "Ganache", sans-serif;
    font-style: italic;
    color: rgba(149, 73, 17, 1);
    text-shadow: -3px -3px 0 #fff, 3px -3px 0 #fff, -3px 3px 0 #fff,
      3px 3px 0 #fff;
    line-height: 40px;
  }

  @media (max-width: 768px) {
    left: 3px;
    .content-main {
      font-size: 14px;
    }

    .content-coins {
      font-size: 28px;
      line-height: 34px;
    }

    .button-action-cong .button-action-cong-content {
      font-size: 14px;
    }

    .button-action-cong img {
      width: 80%;
      min-height: 40px;
      height: auto;
    }

    .content-footer {
      font-size: 12px;
    }
  }

  @media (max-width: 576px) {
    .content-coins {
      font-size: 22px;
      line-height: 26px;
    }

    .button-action-cong-content {
      font-size: 14px;
    }

    .button-action-cong img {
      width: 90%;
      min-height: 40px;
      height: auto;
    }

    .content-main {
      font-size: 13px;
    }

    .content-footer {
      font-size: 11px;
    }

    .button-action-cong {
      margin-bottom: 6px;
    }

    .content-coins {
      margin: 6px 0;
      margin-top: 0;
    }

    .img-prize {
      margin: 6px 0;
    }
  }

  @media (max-width: 470px) {
    .container-popup-cong-mini-main {
      padding-top: 30px;
    }

  }
`;
